import React from "react";
import {InputRowContainer, InputRowTitle} from "./InputRow.styles";
import {Col} from "antd";

export const InputRow = ({title, content, extra, ...props}) => {
    return (
        <InputRowContainer {...props}>
            <Col span="8">
                <InputRowTitle>{title}</InputRowTitle>
                <Col>{extra}</Col>
            </Col>
            <Col span="16">{content}</Col>
        </InputRowContainer>
    );
};
